module.exports = __webpack_public_path__ + "static/media/anvita_mahajan.756786b8.jpg";